import { Getter, GetterTree } from 'vuex';
import { AdpFileControlState } from '@/store/modules/adp-file-control/index';
import { RootState } from '@/store';
import {
  ADP_FILES_ERRORS,
  ADP_FILES_LIST,
  ADP_FILES_LOADING, APD_CUSTOMERS,
} from '@/types/adp-file-control.types';
import { Grid } from '@/models/Grid.model';
import { AdpFileControlModel } from '@/models/backoffice/AdpFileControlModel';

export const getters: GetterTree<AdpFileControlState, RootState> = {

  [ADP_FILES_ERRORS](state): string[] {
    return state.adpFilesErrors;
  },

  [ADP_FILES_LOADING](state): boolean {
    return state.adpFilesLoading;
  },

  [ADP_FILES_LIST](state): Grid<AdpFileControlModel> {
    return state.adpFileList;
  },

  [APD_CUSTOMERS](state): Grid {
    return state.adpCustomers;
  },
};